import * as THREE from 'three';
import {BufferGeometry, Vector3} from "three";

export class Grid {
    private group: THREE.Group;
    private material: THREE.LineBasicMaterial;
    private cellSize: number;
    private gridHalfSize: number;

    constructor(
        scene: THREE.Scene,
        gridHalfSize: number = 101,
        cellSize: number = 2,
        y: number = -0.01
    ) {
        this.gridHalfSize = gridHalfSize;
        this.cellSize = cellSize;
        this.material = new THREE.LineBasicMaterial({ color: 0xdce9e9 });
        this.group = new THREE.Group();

        // Création des lignes de la grille
        for (let i: number = -this.gridHalfSize; i <= this.gridHalfSize; i += this.cellSize) {
            // Lignes horizontales
            const pointsH: Vector3[] = [
                new THREE.Vector3(-this.gridHalfSize, y, i),
                new THREE.Vector3(this.gridHalfSize, y, i)
            ];
            const geometryH: BufferGeometry = new THREE.BufferGeometry().setFromPoints(pointsH);
            const lineH = new THREE.Line(geometryH, this.material);
            this.group.add(lineH);

            // Lignes verticales
            const pointsV: Vector3[] = [
                new THREE.Vector3(i, y, -this.gridHalfSize),
                new THREE.Vector3(i, y, this.gridHalfSize)
            ];
            const geometryV: BufferGeometry = new THREE.BufferGeometry().setFromPoints(pointsV);
            const lineV = new THREE.Line(geometryV, this.material);
            this.group.add(lineV);
        }
        scene.add(this.group);
    }

    // Cette méthode met à jour la position de la grille pour qu'elle reste centrée sur la caméra
    update(cameraPosition: THREE.Vector3): void {
        this.group.position.x = Math.floor(cameraPosition.x / this.cellSize) * this.cellSize;
        this.group.position.z = Math.floor(cameraPosition.z / this.cellSize) * this.cellSize;
    }
}
